export default class LinkToCredits {
    constructor({ el, container }) {
        const credits = container.querySelector(".wp-block-cinetic-creatives-blocks-credits")
        if (credits) {
            const $moreButton = el.querySelector(".more-button")
            $moreButton.classList.add("active")
            $moreButton.addEventListener("click", () => {
                gsap.to(window, { scrollTo: {y: credits, offsetY: 80}, duration: 1 })
            })
        }
    }


    dispose() {

    }
}